module.exports = __webpack_public_path__ + "img/Panicum_hallii.5c0760db.jpg";